import { cx } from '@platform/core/lib/cx';
import type { IControlProps } from '../IControlProps';
import { isShortText } from '../options/isShortText';

/** Найбільша довжина однорядкового тексту (UIUX/field-types/text). */
const MAX_LENGTH = 255;

/**
 * Однорядковий текст (UIUX/field-types/text, short-text; controls/text-input): 34px (sm/inline — 30px), 14px 500, не довше 255 знаків,
 * пробіли по краях прибираються при виході з поля; коди й номери (короткий текст) — без автовеликих літер і перевірки правопису.
 */
export function TextInput({ value, onChange, readOnly, id, field, size = 'md', invalid, placeholder, autoFocus }: IControlProps<string>) {
  const text = String(value ?? '');
  const short = isShortText(field);
  return (
    <input id={id} className={cx('control', 'fc-text', size !== 'md' && `fc--${size}`, short && 'fc-text--short', readOnly && 'control--ro')}
      value={text} readOnly={readOnly} maxLength={MAX_LENGTH} aria-invalid={invalid || undefined} placeholder={placeholder} autoFocus={autoFocus}
      autoCapitalize={short ? 'off' : undefined} spellCheck={short ? false : undefined} title={readOnly && text ? text : undefined}
      onChange={(e) => onChange(e.target.value)} onBlur={() => { const trimmed = text.trim(); if (trimmed !== text) onChange(trimmed); }} />
  );
}
